// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body, #root {
  min-height: 100vh;
  margin: 0;
  padding: 0;
  font-family: 'Roboto', sans-serif;
  background: radial-gradient(circle at center, #0E8CA5 0%, #157683 50%, #145D5E 100%);
}

/* Override browser autofill blue background on all inputs */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 1000px #ffffff inset !important;
  box-shadow: 0 0 0 1000px #ffffff inset !important;
  -webkit-text-fill-color: inherit !important;
}
`, "",{"version":3,"sources":["webpack://./src/client/styles/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,iCAAiC;EACjC,oFAAoF;AACtF;;AAEA,4DAA4D;AAC5D;;;;EAIE,yDAAyD;EACzD,iDAAiD;EACjD,2CAA2C;AAC7C","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml, body, #root {\n  min-height: 100vh;\n  margin: 0;\n  padding: 0;\n  font-family: 'Roboto', sans-serif;\n  background: radial-gradient(circle at center, #0E8CA5 0%, #157683 50%, #145D5E 100%);\n}\n\n/* Override browser autofill blue background on all inputs */\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 1000px #ffffff inset !important;\n  box-shadow: 0 0 0 1000px #ffffff inset !important;\n  -webkit-text-fill-color: inherit !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
